import React from "react";
import { Row, Col } from "@folio/stripes/components";
import styles from "./RenderField.module.css";
var RenderField = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement(Row, { className: styles.fieldRow },
        React.createElement(Col, { xs: 12 },
            React.createElement("div", { className: styles.labelContainer },
                React.createElement("strong", { className: styles.label }, label)),
            React.createElement("div", null, value || "N/A"))));
};
export default RenderField;
